// 系统管理子路由注册表。这里只把稳定的 group/section 映射到页面组件，避免导航配置文件引入页面依赖。
import AccountAddPage from '../account/pages/add/AccountAddPage.js';
import AccountListPage from '../account/pages/list/AccountListPage.js';
import VideoTypeManagementPage from '../videoType/VideoTypeManagementPage.js';
import VideoMaterialCategoriesPage from '../videoEditing/pages/materialCategories/VideoMaterialCategoriesPage.js';
import VideoMaterialsPage from '../videoEditing/pages/materials/VideoMaterialsPage.js';
import VideoTemplatesPage from '../videoEditing/pages/templates/VideoTemplatesPage.js';
import JianyingDevicesPage from '../jianying/pages/devices/JianyingDevicesPage.js';
import JianyingTemplateConfigurationPage from '../jianying/pages/templates/JianyingTemplateConfigurationPage.js';
import JianyingTemplatesPage from '../jianying/pages/templates/JianyingTemplatesPage.js';
import {
  SYSTEM_MANAGEMENT_GROUPS,
  SYSTEM_MANAGEMENT_SECTIONS,
} from './systemManagementNavigation.js';

const buildRoutes = (group, routes) =>
  routes.map(([section, Component]) => ({
    group,
    section,
    path: `${group}/${section}`,
    Component,
  }));

export const SYSTEM_MANAGEMENT_ROUTES = [
  ...buildRoutes(SYSTEM_MANAGEMENT_GROUPS.JIANYING, [
    [SYSTEM_MANAGEMENT_SECTIONS.JIANYING_TEMPLATES, JianyingTemplatesPage],
    [SYSTEM_MANAGEMENT_SECTIONS.JIANYING_DEVICES, JianyingDevicesPage],
  ]),
  {
    group: SYSTEM_MANAGEMENT_GROUPS.JIANYING,
    section: SYSTEM_MANAGEMENT_SECTIONS.JIANYING_TEMPLATES,
    path: 'jianying/templates/:templateId',
    Component: JianyingTemplateConfigurationPage,
  },
  ...buildRoutes(SYSTEM_MANAGEMENT_GROUPS.VIDEO_EDITING, [
    [SYSTEM_MANAGEMENT_SECTIONS.MATERIALS, VideoMaterialsPage],
    [SYSTEM_MANAGEMENT_SECTIONS.MATERIAL_CATEGORIES, VideoMaterialCategoriesPage],
    [SYSTEM_MANAGEMENT_SECTIONS.TEMPLATES, VideoTemplatesPage],
  ]),
  ...buildRoutes(SYSTEM_MANAGEMENT_GROUPS.VIDEO_TYPES, [
    [SYSTEM_MANAGEMENT_SECTIONS.VIDEO_TYPES, VideoTypeManagementPage],
  ]),
  ...buildRoutes(SYSTEM_MANAGEMENT_GROUPS.ACCOUNT, [
    [SYSTEM_MANAGEMENT_SECTIONS.ACCOUNTS, AccountListPage],
    [SYSTEM_MANAGEMENT_SECTIONS.ADD_ACCOUNT, AccountAddPage],
  ]),
];
